export class PhotoSliderModule {
    initialize() {
        this.sliders = document.querySelectorAll('.photo-slider');
        this.sliders.forEach(slider => {
            new PhotoSlider().initialize(slider);
        });
    }
}

class PhotoSlider {
    initialize(slider) {
        this.rootElement = slider;
        this.imageButtons = this.rootElement.querySelectorAll('.photo-slider-image-button');
        this.images = this.rootElement.querySelectorAll('.photo-slider-image');

        this.preview = this.rootElement.querySelector(".photo-slider-preview");
        this.previewImg = this.preview.querySelector(".photo-slider-preview-image");
        this.previewPrevButton = this.preview.querySelector(".photo-slider-preview-prev");
        this.previewNextButton = this.preview.querySelector(".photo-slider-preview-next");
        this.previewCloseButton = this.preview.querySelector(".photo-slider-preview-close");
        this.previewCloseAccessibleButton = this.preview.querySelector(".photo-slider-preview-close-accessible");

        this.horizontalScrollContainer = this.rootElement.querySelector('horizontal-scroll-container');
        this.horizontalScroll = this.horizontalScrollContainer.querySelector('.horizontal-scroll');
        this.horizontalScrollItems = this.horizontalScroll.querySelectorAll('.navigation-item');


        // The minimal width for zooming is the breakpoint-md from Bootstrap
        const breakpointMd = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-md');
        this.minimalWidthForZoom = Number(breakpointMd.replace('px', ''));

        this.activeImageIndex = -1; // not set

        this.setEventListeners();
    }

    setEventListeners() {
        this.imageButtons.forEach(imageButton => {
            let image = imageButton.querySelector('img');
            if (image) {
                imageButton.addEventListener('click', () => {
                    this.onImageClick(image);
                });
            }
        });

        this.previewPrevButton.addEventListener('click', () => {
            this.previousImage();
        });

        this.previewNextButton.addEventListener('click', () => {
            this.nextImage();
        });

        this.preview.addEventListener('click', (event) => {
            if (event.target === this.preview) {
                this.closePreview();
            }
        });

        this.previewCloseButton.addEventListener('click', () => {
            this.closePreview();
        });

        this.previewCloseButton.addEventListener('blur', (event) => {
            this.closePreview();
        });

        this.previewCloseAccessibleButton.addEventListener('click', () => {
            this.closePreview();
        });

        // break out of the detail view and focus back on the main view
        this.previewCloseAccessibleButton.addEventListener('focus', (event) => {
            this.closePreview();
        });

        window.addEventListener('resize', (event) => {
            // Zoom has not a lot of function on mobile devices, because of the size
            if (window.innerWidth < this.minimalWidthForZoom) {
                this.closePreview();
            }
        });

        // Next/previous image when using arrow keys, close preview with escape
        document.addEventListener('keydown', (event) => {
            if (this.activeImageIndex === -1) return;

            if (event.key === "Escape") {
                this.closePreview();
            } else if (event.key === "ArrowLeft") {
                event.preventDefault();
                this.previousImage();
            } else if (event.key === "ArrowRight") {
                event.preventDefault();
                if (this.activeImageIndex < this.images.length - 1) {
                    this.nextImage();
                } else {
                    if (this.activeImageIndex === this.images.length - 1) {
                        this.closePreview();
                    }
                }
            }
        });
    }

    onImageClick(image) {
        this.activeImageIndex = parseInt(image.dataset.index);

        this.setHorizontalScrollPosition();
        this.renderButtons();

        this.previewImg.src = image.dataset.srcView;
        this.previewImg.title = image.dataset.title;
        this.previewImg.alt = image.dataset.title;
        this.preview.classList.remove("hidden");
        this.previewImg.classList.remove("hidden");
        this.previewImg.focus();

        console.log(`this.previewImg`, this.previewImg);

        // Add class to body when photo slider is open
        document.body.classList.add("photo-slider-open");
    }

    setHorizontalScrollPosition() {
        this.horizontalScrollContainer.dataset.currentItem = this.activeImageIndex;

        if (this.horizontalScrollItems && this.horizontalScrollItems[this.activeImageIndex]) {
            const targetItem = this.horizontalScrollItems[this.activeImageIndex];
            const firstItem = this.horizontalScrollItems[0];

            if (targetItem && firstItem) {
                let leftOffsetCalculation = targetItem.offsetLeft - firstItem.offsetLeft;
                this.horizontalScroll.scroll({top: 0, left: leftOffsetCalculation});
            }
        }
    }

    renderButtons() {
        // Hide buttons if first or last image

        if (this.activeImageIndex === 0) {
            this.previewPrevButton.classList.add("hidden");
        } else {
            this.previewPrevButton.classList.remove("hidden");
        }

        if (this.activeImageIndex === this.images.length - 1) {
            this.previewNextButton.classList.add("hidden");
            this.previewCloseAccessibleButton.classList.remove("hidden");
        } else {
            this.previewNextButton.classList.remove("hidden");
            this.previewCloseAccessibleButton.classList.add("hidden");
        }
    }

    closePreview() {
        this.preview.classList.add("hidden");
        this.previewImg.classList.add("hidden");
        if (
            this.imageButtons
            &&
            typeof this.imageButtons[this.activeImageIndex] !== 'undefined'
        ) {
            let image = this.imageButtons[this.activeImageIndex].querySelector('img');
            if (image) {
                image.focus();
            }
        }

        this.activeImageIndex = -1;
        // Remove class from body when photo slider is closed
        document.body.classList.remove("photo-slider-open");
    }

    previousImage() {
        if (this.activeImageIndex < 1) return;

        const image = this.images[this.activeImageIndex - 1];
        if (image) this.onImageClick(image);
    }


    nextImage() {
        if (this.activeImageIndex >= this.images.length) return;
        const image = this.images[this.activeImageIndex + 1];
        if (image) this.onImageClick(image);
    }
}